import React, { useState } from "react";
import { motion } from "framer-motion";
import S from "./ImageSlideshow.styled";
import { MainInner, MainSection, motionAnimation } from "@/styles/global";
import { DisplayHeadingXS } from "@/styles/typography";
import { IWPImage, IWPVideo } from "@/src/types";
import { BackgroundImage, Icon, Link, Wysiwyg } from "@/styles/components";
import Youtube from "@/components/global-components/Youtube";

export interface ImageSlideshowProps {
  blockId: string;
  size?: "small" | "large";
  gradient?: boolean;
  images: {
    title: string;
    text: string;
    image: IWPImage;
    mediaType: "image" | "video";
    video: IWPVideo;
  }[];
}

const ImageSlideshow: React.FC<ImageSlideshowProps> = ({
  blockId = "",
  size = "large",
  images,
  gradient,
}) => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const minIndex = 0;
  const maxIndex = images.length - 1;
  const { title, text, image, mediaType, video } = images[currentIndex];

  const handlePress = (left?: boolean) => {
    setCurrentIndex(
      left
        ? currentIndex === minIndex
          ? maxIndex
          : currentIndex - 1
        : currentIndex === maxIndex
          ? minIndex
          : currentIndex + 1
    );
  };

  const NavigationButton = ({ left }: { left?: boolean }) => (
    <div onClick={() => handlePress(left)}>
      <Icon src={left ? "ArrowLeft" : "ArrowRight"} color="white" />
    </div>
  );

  return (
    <S.Section id={blockId} as={motion.section} {...motionAnimation}>
      <S.Inner>
        <S.ImageContainer $size={mediaType === "video" ? "video" : size}>
          {mediaType === "video" ? (
            <>
              <S.VideoContainer>
                <Youtube video={video} />
              </S.VideoContainer>
            </>
          ) : (
            <>
              <BackgroundImage image={image} radius={21} />
              {gradient && <S.Overlay />}
              <S.TextContainer>
                <S.TextWrapper
                  as={motion.div}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  key={currentIndex}
                >
                  <DisplayHeadingXS
                    color="white"
                    size="36px"
                    margin={text && "0 0 12px 0"}
                  >
                    {title}
                  </DisplayHeadingXS>
                  <Wysiwyg color="white" weight={500} html={text} />
                </S.TextWrapper>
              </S.TextContainer>
            </>
          )}
          <S.ButtonsContainer>
            <S.ButtonWrapper>
              <NavigationButton left />
              <NavigationButton />
            </S.ButtonWrapper>
          </S.ButtonsContainer>
        </S.ImageContainer>
      </S.Inner>
    </S.Section>
  );
};

export default ImageSlideshow;
